import React, { useEffect } from 'react';
import Coupon from './Coupon';
import AppleStoreSvg from '../../../styles/assets/bitstop-app-apple-store.svg';
import GoogleStoreSvg from '../../../styles/assets/bitstop-app-google-store.svg';
import AppleStoreQR from '../../../styles/assets/bitstop-app-apple-store-qr.png';
import GoogleStoreQR from '../../../styles/assets/bitstop-google-app-store-qr.png';
import sketchedArrow from '../../../styles/assets/sketched-arrow.png';
import './RewardsCenter.css';
import useTranslations from '../../../hooks/useTranslations';
import { RewardsCenter as translations } from '../../../middlewares/i18n';
import BitstopAppSvg from '../../../styles/assets/bitstop-app-layout-3.png';

const RewardsCenter = ({ openModal, setOpenModal }) => {
  const i18n = useTranslations(translations);
  const isOpen = openModal === 'rewards';

  const openRewardsCenter = () => setOpenModal('rewards');
  const closeRewardsCenter = () => setOpenModal(null);

  useEffect(() => {
    const pulseAnimation = () => {
      const element = document.getElementById('pulse-element');
      if (element) {
        element.classList.add('animate__custom-pulse');
        setTimeout(() => {
          element.classList.remove('animate__custom-pulse');
        }, 1000);
      }
    };

    pulseAnimation();
    const intervalId = setInterval(pulseAnimation, 5000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className={`rewards-center__wrapper ${isOpen ? 'open' : ''}`}>
      {isOpen && <div className="rewards-center__modal-backdrop" onClick={closeRewardsCenter} />}
      {!isOpen ? (
        <>
          <button className="rewards-center__button" onClick={openRewardsCenter}>
            <div id="pulse-element" className="rewards-center__icon-open">🎁</div>
          </button>
          <div className="modal-button-label">{i18n.btnLabel}</div>
        </>
      ) : (
        <button className="rewards-center__button help-center__button--close" onClick={closeRewardsCenter}>
          <div className="rewards-center__icon-close" />
        </button>
      )}
      {isOpen && (
        <div className="rewards-center">
          <center>
            <h1>{i18n.haveACoupon}</h1>
            <Coupon />
            <small className="disclaimer" style={{marginBottom: "8px"}}>{i18n.enterCouponCode}</small>
            <small className="disclaimer"><em>{i18n.takePicReminder}</em></small>
          </center>
          <hr />
          <center class="want-more__wrapper">
            <h1>{i18n.wantMore}</h1>
            <div className="app-stores columns">
              <div className="col apple">
                <img src={AppleStoreSvg} className="store-icon" alt="Apple App Store" />
                <img src={AppleStoreQR} className="qr-code" alt="Apple App Store QR Redirect" />
              </div>
              <div className="col google">
                <img src={GoogleStoreSvg} className="store-icon" alt="Google Play Store" />
                <img src={GoogleStoreQR} className="qr-code" alt="Google Play Store QR Redirect" />
              </div>
            </div>
            <img className="arrow" src={sketchedArrow} alt="Scan Me!" />
            <p>{i18n.whyDownload}</p>
          </center>
          <br />
          <br />
          <img className="mobile-app" src={BitstopAppSvg} alt="Bitstop Mobile App" />
        </div>
      )}
    </div>
  );
};

export default RewardsCenter;